/**
 * Variant-specific media gallery filtering for apparel products.
 * Filters product images by color based on [color:value] tags in image alt text,
 * parsed into data-media-color attributes by Liquid.
 */
document.addEventListener('DOMContentLoaded', () => {
  const HIDDEN_CLASS = 'media-item--color-hidden';

  // Determine which option position holds Color (1-indexed → variant.option1/option2/option3)
  const indexEl = document.querySelector('[id^="MahjColorOptionIndex"]');
  if (!indexEl) return;
  const colorOptionKey = `option${indexEl.textContent.trim()}`;

  function getColorFromVariant(variant) {
    if (!variant) return null;
    const val = variant[colorOptionKey];
    return val ? val.toLowerCase() : null;
  }

  function filterGallery(color) {
    const gallery = document.querySelector('media-gallery');
    if (!gallery || !color) return;

    const viewer = gallery.querySelector('[id^="GalleryViewer"] ul');
    if (!viewer) return;

    const activeMedia = viewer.querySelector('li.is-active');
    let activeIsHidden = false;
    let firstVisible = null;

    viewer.querySelectorAll('li[data-media-color]').forEach((li) => {
      const tag = li.dataset.mediaColor;
      const visible = tag === '' || tag === color;

      if (visible) {
        li.classList.remove(HIDDEN_CLASS);
        li.removeAttribute('aria-hidden');
        if (!firstVisible) firstVisible = li;
      } else {
        li.classList.add(HIDDEN_CLASS);
        li.setAttribute('aria-hidden', 'true');
        if (li === activeMedia) activeIsHidden = true;
      }
    });

    // Sync thumbnails
    const thumbList = gallery.querySelector('[id^="Slider-Thumbnails"]');
    if (thumbList) {
      thumbList.querySelectorAll('li[data-media-color]').forEach((li) => {
        const tag = li.dataset.mediaColor;
        const visible = tag === '' || tag === color;
        if (visible) {
          li.classList.remove(HIDDEN_CLASS);
          li.removeAttribute('aria-hidden');
          li.querySelectorAll('button').forEach((b) => b.removeAttribute('tabindex'));
        } else {
          li.classList.add(HIDDEN_CLASS);
          li.setAttribute('aria-hidden', 'true');
          li.querySelectorAll('button').forEach((b) => b.setAttribute('tabindex', '-1'));
        }
      });
    }

    // Only switch active media if the current active one becomes hidden
    if (activeIsHidden && firstVisible) {
      const mediaId = firstVisible.dataset.mediaId;
      gallery.setActiveMedia?.(mediaId, false);
    }

    // Update slider counter
    const counter = gallery.querySelector('.slider-counter--total');
    if (counter) {
      const visibleCount = viewer.querySelectorAll(`li[data-media-color]:not(.${HIDDEN_CLASS})`).length;
      counter.textContent = visibleCount;
    }
  }

  // Listen for variant changes — read color from event payload, not swatch DOM
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    requestAnimationFrame(() => {
      const color = getColorFromVariant(event.data.variant);
      if (color) filterGallery(color);
    });
  });

  // Initial page load: filter based on pre-selected variant
  // Scope to the same section as the color option index element
  const sectionId = indexEl.id.replace('MahjColorOptionIndex-', '');
  const sectionEl = document.querySelector(`product-info[data-section="${sectionId}"]`);
  if (sectionEl) {
    const variantJson = sectionEl.querySelector('variant-selects [data-selected-variant]');
    if (variantJson) {
      try {
        const variant = JSON.parse(variantJson.innerHTML);
        const color = getColorFromVariant(variant);
        if (color) filterGallery(color);
      } catch (e) {
        /* no-op — variant JSON not available */
      }
    }
  }
});
